import React, { Component, ComponentType } from "react"

import { BulkSMSCreatorSelect, ContactSelect } from "app/static/frontend/selects/containers/PieSelect"
import { createNumericTripletMultiFilter, datePickerGenericFilter } from "shared/search/containers/Filter/Filters"
import { searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"
import { SupporterFilterableListView } from "shared/search/containers/FilterableListView/FilterableListViews"

interface BulkSMSCreatedByFilterProps {
    displayLabel: string
    filterComponent: ComponentType<any>
    filterKey: string
    uniqueFilterId: string
    dataTypeLabel: string
    selectComponent: ComponentType<any>
    placeholder?: string
}

export class BulkSMSCreatedByFilter extends Component<BulkSMSCreatedByFilterProps> {
    static get defaultProps() {
        return {
            displayLabel: "Creator",
            filterComponent: searchifySelectGenericFilter,
            filterKey: "created_by_user",
            uniqueFilterId: "bulkSMSCreatedByFilter",
            dataTypeLabel: "Creator",
            selectComponent: BulkSMSCreatorSelect,
        }
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} placeholder="Select creator" />
    }
}

interface BulkSMSDateSentStartFilterProps {
    filterComponent: ComponentType<any>
    uniqueFilterId: string
    filterKey: string
    displayLabel: string
    noFuture: boolean
}

export class BulkSMSDateSentStartFilter extends Component<BulkSMSDateSentStartFilterProps> {
    static get defaultProps() {
        return {
            filterComponent: datePickerGenericFilter,
            uniqueFilterId: "bulkSMSDateSentStartFilter",
            filterKey: "date_sent_start",
            displayLabel: "Start",
            noFuture: true,
        }
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

interface BulkSMSDateSentEndFilterProps {
    filterComponent: ComponentType<any>
    uniqueFilterId: string
    filterKey: string
    displayLabel: string
    noFuture: boolean
}

export class BulkSMSDateSentEndFilter extends Component<BulkSMSDateSentEndFilterProps> {
    static get defaultProps() {
        return {
            filterComponent: datePickerGenericFilter,
            uniqueFilterId: "BulkSMSDateSentEndFilter",
            filterKey: "date_sent_end",
            displayLabel: "End",
            noFuture: true,
        }
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

interface BulkSMSReceivedByFilterProps {
    filterComponent: ComponentType<any>
    uniqueFilterId: string
    filterKey: string
    displayLabel: string
    dataTypeLabel: string
    searchifyFLV: ComponentType<any>
    selectComponent: ComponentType<any>
}

export class BulkSMSReceivedByFilter extends Component<BulkSMSReceivedByFilterProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "bulkSMSReceivedByFilter",
            filterKey: "bulk_sms_received_by",
            dataTypeLabel: "Received",
            displayLabel: "Received",
            searchifyFLV: SupporterFilterableListView,
            selectComponent: ContactSelect,
        }
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent placeholder="Select contacts" {...this.props} />
    }
}

interface BulkSMSClickedByFilterProps {
    filterComponent: ComponentType<any>
    uniqueFilterId: string
    filterKey: string
    displayLabel: string
    dataTypeLabel: string
    searchifyFLV: ComponentType<any>
    selectComponent: ComponentType<any>
}

export class BulkSMSClickedByFilter extends Component<BulkSMSClickedByFilterProps> {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "bulkSMSClickedByFilter",
            filterKey: "bulk_sms_clicked_by",
            displayLabel: "Clicked",
            dataTypeLabel: "Clicked",
            searchifyFLV: SupporterFilterableListView,
            selectComponent: ContactSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent placeholder="Select contacts" {...this.props} />
    }
}

export const BulkSMSClicksCountFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "bulkSMSClicksCountFilter",
    displayLabel: "Clicks",
    filterKeyMapping: {
        left: "click_count_less_than",
        center: "click_count_is_exactly",
        right: "click_count_greater_than",
    },
    placeholder: "Enter a number",
})

export const BulkSMSSentCountFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "bulkSMSSentCountFilter",
    displayLabel: "Sent",
    filterKeyMapping: {
        left: "sent_count_less_than",
        center: "sent_count_is_exactly",
        right: "sent_count_greater_than",
    },
    placeholder: "Enter a number",
})
